module.exports = __webpack_public_path__ + "img/pk.e5cae3e6.svg";